import { render } from "./TypingAnimation.vue?vue&type=template&id=e6400fc4&scoped=true"
import script from "./TypingAnimation.vue?vue&type=script&lang=js"
export * from "./TypingAnimation.vue?vue&type=script&lang=js"

import "./TypingAnimation.vue?vue&type=style&index=0&id=e6400fc4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6400fc4"]])

export default __exports__